import privacyPolicySource from '../../resources/legal/privacy-policy.md?raw';
import termsAndConditionsSource from '../../resources/legal/terms-and-conditions.md?raw';

export const legalDocuments = [
  {
    label: 'Privacy Policy',
    path: '/privacy-policy',
    source: privacyPolicySource,
  },
  {
    label: 'Terms & Conditions',
    path: '/terms-and-conditions',
    source: termsAndConditionsSource,
  },
] as const;

export type LegalDocument = (typeof legalDocuments)[number];
